import * as React from 'react';
import { Modal, Button, RadioGroupField } from '@dsx/react';
import { type DSXSelectOption } from '~/components/DSX/Select';

export interface ISelectMasterItemTypeModalProps {
	show: boolean;
	selectedType: string;
	onTypeChange(type: string): void;
	onClose(): void;
	onCreate(): void;
}

export enum MasterItemType {
	Dynamic = 'Dynamic',
	Manual = 'Manual',
}

export class SelectMasterItemTypeModal extends React.Component<ISelectMasterItemTypeModalProps> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { show, selectedType, onTypeChange, onClose, onCreate } = this.props;

		const radioOptions = [
			{
				label: 'Dynamic Master Item',
				value: MasterItemType.Dynamic,
				help: 'Select tags to automatically populate products',
			},
			{
				label: 'Manual Master Item',
				value: MasterItemType.Manual,
				help: 'Search and add products to this master item',
			},
		];

		return (
			<Modal
				header="Select Master Item Type"
				label="Select Master Item Type Modal"
				isOpen={show}
				onClose={onClose}
				footer={
					<>
						<Button key="cancel-button" onClick={onClose}>
							Cancel
						</Button>
						<Button key="continue-button" onClick={onCreate} variant="primary">
							Continue
						</Button>
					</>
				}
			>
				<RadioGroupField
					label="Master Item Type"
					options={radioOptions}
					value={selectedType}
					onChange={(value) => {
						const selectedOption = value.target.value;
						if (selectedOption) {
							onTypeChange(selectedOption);
						}
					}}
					name="master-item-type"
					required={false}
				/>
			</Modal>
		);
	}

	public onTypeSelect = (option: DSXSelectOption) => {
		this.props.onTypeChange(option.value);
	};
}
